module.exports = __webpack_public_path__ + "img/screen-opps.8f677ec4.png";